import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  BigPicklistInput,
  BodyTextLarge,
  CurrencyInputSmall,
  HeadlineTextLarge,
  TitleTextLarge,
} from 'Packages/FacetDesign/Components';

export const RetirementAgeGoalSeekPriorityOverride = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => HeadlineTextLarge,
    _customProps: {
      color: 'textSecondary',
    },
  }, overrideReadOnly)
  .nameOverride(['priorityHeader', 'endBalanceHeader', 'endBalanceDisabledHeader'], {
    _component: () => TitleTextLarge,
  }, overrideReadOnly)
  .nameOverride('priority', {
    _component: () => BigPicklistInput,
  }, overrideReadOnly)
  .nameOverride(['endBalance', 'endBalanceDisabled'], {
    _component: () => CurrencyInputSmall,
  }, overrideReadOnly)
  .nameOverride('loadingDescription', {
    _component: () => BodyTextLarge,
  }, overrideReadOnly);
